import { render, staticRenderFns } from "./VSwitch.vue?vue&type=template&id=c0095ed2&scoped=true"
import script from "./VSwitch.vue?vue&type=script&lang=js"
export * from "./VSwitch.vue?vue&type=script&lang=js"
import style0 from "./VSwitch.vue?vue&type=style&index=0&id=c0095ed2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0095ed2",
  null
  
)

export default component.exports